import { render } from "./PaymentNotification.vue?vue&type=template&id=8ca75e78&scoped=true"
import script from "./PaymentNotification.vue?vue&type=script&lang=js"
export * from "./PaymentNotification.vue?vue&type=script&lang=js"

import "./PaymentNotification.vue?vue&type=style&index=0&id=8ca75e78&lang=css"
import "./PaymentNotification.vue?vue&type=style&index=1&id=8ca75e78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ca75e78"]])

export default __exports__